var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Card-wrapper",class:_vm.classes},[_c('div',{staticClass:"Card py-5 px-3 px-sm-5 text-center text-lg-left"},[_vm._t("Card-title"),_vm._v(" "),_vm._t("Card-body"),_vm._v(" "),_vm._t("Card-button")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72f786b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = Agty
// module chunks = 0